module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch19"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch19a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch19"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("ODD VODKAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Vodka is practically tasteless, which means that distilleries can add whatever bizarre flavors they want to it. For example…")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("GRASS:")]), _vm._v(" Polish company Bak makes Bison Grass vodka. It’s not bison-flavored—it’s grass-flavored (and bison eat grass). The grass infusion leaves a small amount of coumarin, which is a main ingredient in rat poison and leads to liver damage (but then, so does vodka).")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("HORSERADISH:")]), _vm._v(" Sputnik, a Russian distillery, makes a vodka flavored with “pure organic horseradish.” Wasabi, another kind of horseradish, gives Green Geisha from Oregon’s Hard Times Distillery its distinctive flavor (and burn).")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("PORK:")]), _vm._v(" Bakon vodka is infused with the flavor of pork fat. The bottle is bacon-shaped, too.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("PICKLE:")]), _vm._v(" Another Russian distillery, Vodka Garant, makes a pickle-and-garlic vodka. If that’s not to your taste, American distillery Naked Jay makes a pickle-flavored vodka. No garlic.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("PEANUT BUTTER:")]), _vm._v(" Van Goh produces a PB&J vodka, while NutLiquor makes one free of jelly, just peanut butter. Both are, surprisingly, free of peanut products.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("BUBBLE GUM:")]), _vm._v(" A company called Three Olives makes this vodka.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("SYRUP:")]), _vm._v(" Birch syrup is a sweetened tree sap, similar to maple syrup and widely used in Alaska. Alaska Distillery makes a birch syrup vodka. (They also make rhubarb vodka and their most challenging flavor: smoked salmon vodka.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("DESSERT:")]), _vm._v(" Pinnacle manufactures a line of dessert-inspired vodkas, including cotton candy, cupcake, cake batter, and whipped cream.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('b', [_vm._v("ARACHNID:")]), _vm._v(" Skorppio-brand vodka doesn’t have any particular extra flavor, but it does come with a real, de-poisoned scorpion, much like a worm comes in a bottle of mescal.")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("In Japan the number 4 is unlucky (it sounds like the Japanese word for death).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1efa7bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter019.vue
// module id = 135
// module chunks = 0